import Stack from "@mui/material/Stack";
import { BonusObtainType } from "entities/modules/types";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import Select, { SelectOption } from "shared/components/Form/Select";
import { COLOR_BLACK } from "shared/theme/colors";

const options: SelectOption[] = [
  { value: BonusObtainType.Obtainable, label: "Available to opt in" },
  { value: BonusObtainType.Active, label: "Active" },
];

const ModuleConfigurationSection: FC = () => {
  const { bonusObtainType, setBonusObtainType } = useGeneralData();

  const handleObtainTypeChange = (value: string) => {
    setBonusObtainType(value as BonusObtainType);
  };

  return (
    <ContentSection title="MODULE CONFIGURATION">
      <Stack spacing="1rem">
        <Select
          id="bonusObtainType"
          label="Type"
          labelColor={COLOR_BLACK}
          placeholder="Select a type"
          disabledPlaceholder
          fullWidth
          required
          value={bonusObtainType ?? undefined}
          handleChange={handleObtainTypeChange}
          options={options}
        />
      </Stack>
    </ContentSection>
  );
};

export default ModuleConfigurationSection;
